<!-- dashboard.component.html -->


  <!-- Loading state -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>Loading dashboard...</p>
  </div>

  <!-- Error state -->
  <div *ngIf="error && !loading" class="error-container">
    <p class="error-message">{{ error }}. Try again later.</p>
    <p-button label="Retry" (onClick)="loadMetabaseEmbed()" [size]="'small'"></p-button>
  </div>

  <!-- Metabase iframe -->
  <iframe
    *ngIf="iframeUrl && !loading"
    [src]="iframeUrl"
    frameborder="0"
    width="100%"
    height="1600"
    allowtransparency
    style="min-height: 600px;"
  ></iframe>
